import { render, staticRenderFns } from "./SwitchReglementStatusMenu.vue?vue&type=template&id=d472f204&"
import script from "./SwitchReglementStatusMenu.vue?vue&type=script&lang=js&"
export * from "./SwitchReglementStatusMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports